import { useEffect, useState } from 'react';

/**
 * Scroll-state hook — true once `window.scrollY` passes the threshold,
 * false again when back near the top. Short-circuits with the same-value
 * setter so React doesn't re-render on every scroll frame.
 */
export function useIsScrolled(threshold = 8): boolean {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const update = () => setScrolled(window.scrollY > threshold);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, [threshold]);
  return scrolled;
}
